/**
 * Created by asiulik on 19.05.2017.
 */

define(['./changePageDefault', './changePageTeaserExpand', './changePageThemenFinder'], function(changePageDefault, changePageTeaserExpand, changePageThemenFinderBack){

    return {
        changePageDefault: changePageDefault,
        changePageTeaserExpand: changePageTeaserExpand,
        changePageTeaserExpandMobile: changePageTeaserExpand,
        changePageThemenFinderBack: changePageThemenFinderBack
    };

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/page/changePageAnimations/changePageAnimations.js